import React, { useEffect } from 'react';

import { useAppDispatch, useAppSelector } from '../../../../../store';
import { MessagesTable } from '../components/MessagesTable';
import { useLazyGetMessagesQuery } from '../service/messages.api';
import {
    selectAnalyticsFilters,
    updateFilters,
} from '../../../store/analyticFiltersSlice';

export const MessagesContainer = () => {
    const filters = useAppSelector(selectAnalyticsFilters);
    const dispatch = useAppDispatch();

    const [
        getMessages,
        {
            isFetching,
            isLoading,
            data: messages = {
                total_messages: 0,
                messages_tonality: '',
                message_statistic: [],
                user_messages_chart: {},
                message_members_statistic: [],
            },
        },
    ] = useLazyGetMessagesQuery();

    useEffect(() => {
        if (filters) {
            const payload = {
                ...filters,
                community_id: +filters.chat || null,
                period: filters.period || null,
            };
            getMessages(payload, true);
        }
    }, [filters]);

    const onFiltersUpdate = update => {
        dispatch(updateFilters(update));
    };

    return (
        <MessagesTable
            loading={isFetching || isLoading}
            filters={filters}
            onFiltersUpdate={onFiltersUpdate}
            source={messages?.message_members_statistic}
        />
    );
};
